import qs from "qs";
import axios from "axios";
export default function (config) {
    const instance = axios.create({
        baseURL: window.location.href.includes("localhost")
            ? "https://console-mock.apipost.cn/mock/345db551-fa6d-419d-9db4-ac6dbf5d2e36"
            : "https://actcq.web.sdo.com",
        timeout: 5000
    });
    instance.interceptors.request.use(
        (config) => {
            // POST处理
            if (config.method.toLowerCase() == "post") {
                // 上传图片单独配置headers
                if (config.isPicUpload) {
                    config.headers = { "Content-Type": "multipart/form-data" };
                } else {
                    config.data = qs.stringify(config.data);
                }
            }
            return config;
        },
        (err) => {
            CsLib.alert("网络不好，请稍后重试！", 500, "error");
        }
    );
    instance.interceptors.response.use(
        (res) => {
            if (res.data.code == 0) {
                return res.data.msg;
            } else {
                CsLib.alert(res.data.msg, 1200, "error");
            }
        },
        (err) => {
            CsLib.alert("网络不好，请稍后重试！", 500, "error");
        }
    );
    return instance(config);
}
